import type { INavTypeIcon } from './INavTypeIcon';
import { groupByCategory } from './navigation';
import { tileNav } from './tileNav';

/**
 * Плитка типу запису на рівні «Глобально» (прототип v4 modIco шаблону): іконка таблиці (tileNav), тон — категорії шаблону
 * (`module.category`, APP_CAT_TONE прототипу), а не категорії модуля в просторі (справи простору — «Управління», шаблон — «Основа»).
 */
export function globalTypeNav(moduleKey: string, rtKey: string, category: string): INavTypeIcon {
  const nav = tileNav(moduleKey, rtKey);
  return { icon: nav.icon, tone: groupByCategory(category)?.tone ?? nav.tone };
}
